"use client";
import { useState } from "react";
import type { MetricCell } from "@/lib/conditions/metric-strip";

export function MetricStrip({ cells }: { cells: MetricCell[] }) {
  const [open, setOpen] = useState<string | null>(null);
  if (cells.length === 0) return null;
  return (
    <div className="mt-3">
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-[repeat(auto-fit,minmax(120px,1fr))]">
        {cells.map((c) => {
          const expandable = !!c.detail;
          const isOpen = open === c.label;
          const inner = (
            <>
              <div className="text-[10px] font-semibold uppercase tracking-[0.5px] text-text-muted">{c.label}</div>
              <div className="text-[17px] font-bold text-navy tabular-nums leading-tight">{c.value}</div>
              {c.sublabel && <div className="text-[10px] text-text-muted">{c.sublabel}</div>}
            </>
          );
          const cls = "min-h-11 min-w-11 bg-warm-bg border border-border-light rounded-[10px] px-3 py-2.5 text-left";
          return expandable ? (
            <button key={c.label} type="button" onClick={() => setOpen(isOpen ? null : c.label)}
              aria-expanded={isOpen} aria-controls={`metric-detail-${c.label}`}
              className={`${cls} focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 ${isOpen ? "ring-2 ring-gold" : ""}`}>
              {inner}
            </button>
          ) : (
            <div key={c.label} className={cls}>{inner}</div>
          );
        })}
      </div>
      {cells.filter((c) => c.detail).map((c) => (
        <div key={c.label} id={`metric-detail-${c.label}`} hidden={open !== c.label} className="mt-2.5">
          {c.detail?.kind === "visHours" && (
            <div className="flex gap-0.5 overflow-x-auto">
              {c.detail.series.filter((h) => h.isDay).map((h) => (
                <div key={h.hour} className="flex flex-col items-center gap-1 min-w-[26px]">
                  <span className="text-[9px] text-text-muted tabular-nums">{h.hour}</span>
                  <span className="w-full h-3 rounded" style={{ backgroundColor: h.colour }} title={h.label} aria-hidden="true" />
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
